import { siteMeta, heroStats } from "@/mocks/siteMeta";
import { useCopy } from "@/hooks/useCopy";

export default function Hero() {
  const { copiedId, copy } = useCopy();
  const mainEntry = "97v-main.net";

  return (
    <section id="top" className="relative flex items-center overflow-hidden min-h-[660px] lg:min-h-[720px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20flowing%20vermillion%20red%20and%20golden%20amber%20gradient%20light%20streaks%20over%20a%20deep%20charcoal%20base%2C%20soft%20glowing%20bokeh%20particles%2C%20stylized%20artistic%20texture%2C%20high%20contrast%20dark%20tones%20suitable%20for%20white%20text%20overlay%2C%20no%20text%2C%20no%20people%2C%20elegant%20modern%20motion%20graphic%20aesthetic&width=1920&height=1080&seq=hero-97v-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-5xl mx-auto flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/10 border border-white/20 text-background-50 text-xs md:text-sm backdrop-blur-sm animate-fade-up">
            <i className="ri-flashlight-line text-accent-400"></i>
            地址汇总 · 更新于 {siteMeta.updatedDate}
          </span>

          <h1
            className="mt-6 font-heading font-bold text-background-50 leading-tight text-3xl md:text-5xl lg:text-6xl animate-fade-up"
            style={{ animationDelay: "0.08s" }}
          >
            97视频最新网址与APP入口
          </h1>

          <p
            className="mt-5 max-w-3xl text-sm md:text-lg text-background-100 leading-relaxed animate-fade-up"
            style={{ animationDelay: "0.16s" }}
          >
            官网防走失地址一站找到。当地址更换或打不开时，不用再到处搜索 —— 本页长期汇总
            <strong className="text-background-50 font-semibold"> 最新可用网址、APP入口、备用线路 </strong>
            与防走失方法，回到这里即可快速找到能用的访问方式。
          </p>

          <div
            className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto animate-fade-up"
            style={{ animationDelay: "0.24s" }}
          >
            <a
              href="#addresses"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-links-line text-lg"></i>查看最新可用地址
            </a>
            <a
              href="#app"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-white/10 border border-white/25 text-background-50 text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-white/20 transition-colors backdrop-blur-sm"
            >
              <i className="ri-download-2-line text-lg"></i>APP入口与下载方式
            </a>
          </div>

          <div
            className="mt-10 w-full max-w-2xl rounded-lg bg-white/10 border border-white/15 backdrop-blur-md p-4 md:p-5 animate-fade-up"
            style={{ animationDelay: "0.32s" }}
          >
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <div className="flex items-center gap-2 text-background-100 text-xs md:text-sm shrink-0">
                <i className="ri-star-smile-line text-accent-400 text-base"></i>
                当前推荐入口
              </div>
              <code className="text-background-50 font-medium text-sm md:text-base tracking-wide break-all text-left flex-1">
                {mainEntry}
              </code>
              <button
                type="button"
                onClick={() => copy(mainEntry, "hero-main")}
                className="inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-accent-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-colors w-full sm:w-auto justify-center"
              >
                <i className={copiedId === "hero-main" ? "ri-check-line" : "ri-file-copy-line"}></i>
                {copiedId === "hero-main" ? "已复制" : "复制地址"}
              </button>
            </div>
            <p className="mt-3 text-[11px] md:text-xs text-background-200 text-left">
              提示：主线路优先，备用线路兜底。复制后粘贴到浏览器地址栏即可打开。
            </p>
          </div>

          <div
            className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 w-full max-w-3xl animate-fade-up"
            style={{ animationDelay: "0.4s" }}
          >
            {heroStats.map((s) => (
              <div key={s.id} className="flex flex-col items-center gap-1">
                <span className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                  {s.value}
                  <span className="text-sm md:text-base font-normal ml-1 text-background-200">{s.unit}</span>
                </span>
                <span className="text-xs md:text-sm text-background-200">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}